"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
/**
 * Local Imports
 */

const MAX_CARDS = 6;
const Banner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Banner",
  class: "pl-b1s0rrli"
});
const BannerHeadline = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerHeadline",
  class: "pl-b1kene7q"
});
const gridLayout = (selector, sectionName, numPerRow, numCards = MAX_CARDS) => Array(numCards).fill(numCards).reduce((rulesets, _, cardIdx) => ({
  ...rulesets,
  [`& > ${selector}:nth-of-type(${cardIdx + 1})`]: {
    'grid-row-start': `${sectionName}-${Math.floor(cardIdx / numPerRow)}`
  }
}), {});
const cardsPerRowMobile = 2;
const cardsPerRowTablet = 3;
const cardsPerRowDesktop = 6;
const gridBreakpointLayout = cardsPerRow => ({
  ...gridLayout('svg', 'icon', cardsPerRow),
  ...gridLayout('h3.cardTitle', 'title', cardsPerRow),
  ...gridLayout('span.ux-text-paragraph', 'description', cardsPerRow)
});
const CardWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardWrapper",
  class: "pl-c10n7gc0",
  vars: {
    "c10n7gc0-5": [({
      numcards
    }) => Math.min(numcards, cardsPerRowMobile)],
    "c10n7gc0-8": [({
      numcards
    }) => Math.min(numcards, cardsPerRowTablet)],
    "c10n7gc0-11": [({
      numcards
    }) => Math.min(numcards, cardsPerRowDesktop)]
  }
});

/**
 * AllPlansBanner Component.
 * @module AllPlansBanner
 *
 * @param {Object} props React props
 * @param {String} props.id The id of the content item
 * @param {String} props.tagText Tag Text
 * @param {String} props.heading Banner Heading
 * @param {Array} props.rtbCards Rtb Card content
 * @returns {React.ReactElement} AllPlansBanner Component
 * @public
 */

function AllPlansBanner({
  id,
  tagText,
  heading,
  rtbCards,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(Banner, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "all-plans-banner"
  }, rest), /*#__PURE__*/_react.default.createElement(BannerHeadline, {
    "data-cy": "banner-headline"
  }, /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tagText
  }), heading && /*#__PURE__*/_react.default.createElement(_headlineLockup.HeadlineString, {
    heading: heading,
    headlineTag: "h2",
    headlineSize: "h2",
    headlineLineLength: 2
  })), /*#__PURE__*/_react.default.createElement(CardWrapper, {
    numcards: rtbCards?.length ?? 0,
    "data-cy": "card-wrapper"
  }, rtbCards?.map(({
    icon: {
      name
    },
    heading: cardHeading,
    description,
    tooltip
  }, idx) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: idx
  }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: name
  }), /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    className: "cardTitle",
    "data-cy": "card-title",
    text: cardHeading
  }), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    "data-cy": "card-text",
    asType: "paragraph",
    size: -1,
    text: description,
    tooltip: tooltip,
    tag: "span"
  })))));
}
var _default = exports.default = AllPlansBanner;
AllPlansBanner.propTypes = {
  id: _propTypes.default.string,
  tagText: _propTypes.default.string,
  heading: _propTypes.default.string,
  rtbCards: _propTypes.default.arrayOf(_propTypes.default.object)
};